import { Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';

import { VERTICAL_SPACING } from '../../components/EducationalSlide.components';

export function GstExplainer() {
  return (
    <Stack spacing={VERTICAL_SPACING} height="100%">
      <Stack direction="row" spacing={5} height="100%">
        {/* Left Column */}
        <Stack spacing={3} sx={{ width: '38%', height: '100%' }}>
          <Card variant="filled" sx={{ p: 2, height: '100%' }}>
            <EditableRegion regionId="content" />
          </Card>
        </Stack>

        {/* Right Column */}
        <Stack spacing={2} sx={{ width: '56%' }}>
          <EditableRegion regionId="sidebar" />
        </Stack>
      </Stack>
    </Stack>
  );
}
